import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  AppointmentDTO,
  GetAppointmentApiResponse,
  GetAppointmentRequest,
  GetAppointmentResponse,
  NormalizedAppointmentDTO,
} from "../../models/GetAppointment.model";
import { environment } from "../../environments";
const API_URL = environment.apiUrl;

type AppointmentLike = Partial<AppointmentDTO> &
  Partial<NormalizedAppointmentDTO>;

const normalizeAppointment = (
  appointment: AppointmentLike | null | undefined,
): NormalizedAppointmentDTO => ({
  appointment_ID:
    appointment?.appointment_ID ?? appointment?.Appointment_ID ?? 0,
  appointment_ProjectID:
    appointment?.appointment_ProjectID ??
    appointment?.Appointment_ProjectID ??
    0,
  appointment_Status:
    appointment?.appointment_Status ?? appointment?.Appointment_Status ?? 0,
  appointment_ContactID:
    appointment?.appointment_ContactID ??
    appointment?.Appointment_ContactID ??
    0,
  appointment_TypeID:
    appointment?.appointment_TypeID ?? appointment?.Appointment_TypeID ?? 0,
  appointment_ScheduledStart:
    appointment?.appointment_ScheduledStart ??
    appointment?.Appointment_ScheduledStart ??
    "",
  appointment_ScheduledEnd:
    appointment?.appointment_ScheduledEnd ??
    appointment?.Appointment_ScheduledEnd ??
    "",
  appointment_EmployeeID:
    appointment?.appointment_EmployeeID ??
    appointment?.Appointment_EmployeeID ??
    0,
  notes: appointment?.notes ?? appointment?.Notes?.join?.(" ") ?? "",
  project_Name: appointment?.project_Name ?? appointment?.Project_Name ?? "",
});

export const getAppointment = createAsyncThunk<
  GetAppointmentResponse,
  GetAppointmentRequest,
  { rejectValue: string }
>("appointment/getAppointment", async (request, { rejectWithValue }) => {
  try {
    const res = (await (
      await fetch(`${API_URL}Appointment/GetAppointment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
      })
    ).json()) as GetAppointmentApiResponse;

    return {
      ...res,
      appointment: normalizeAppointment(res.appointment),
    };
  } catch (err: any) {
    return rejectWithValue(
      err.response?.data?.Message || "שגיאה בקבלת פרטי פגישה",
    );
  }
});
